// CANONICAL COPY (GH #7115). src/constants/obligations/obl-sdlc-policy.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-sdlc-policy',
  title: 'Verify secure development lifecycle is in place',
  description:
    'Confirm that secure development rules are documented, published, and applied to software development activities. The SDLC policy shall define application security requirements covering authentication, authorisation, input validation and data protection. Secure coding principles and practices shall be applied to prevent common vulnerabilities and reduce the attack surface of developed software. Secure architecture and engineering principles shall be established and applied to any information system implementation, including standard hardening configuration templates for application infrastructure components.',
  category: 'technical',
  scfIds: ['SCF-DEV-001', 'SCF-DEV-002', 'SCF-DEV-003', 'SCF-DEV-004'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [{ type: 'document-published', description: 'SDLC policy is published' }],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
